

// import { useState, useEffect } from "react";
// import AutosuggestInput from "../Doctor/DashboardDr/dashpages/AutosuggestInput";
// import { onValue, ref, getDatabase } from "firebase/database";
// import { app } from "../../src/Doctor/Firebase/firebase.config";
// import AuthModal from "./AuthModal";

// /* ─── static filter options ─── */
// const industries    = ["All Industries","Doctor","Dentist","Physiotherapy","Nurse","Paramedical","Ayurveda"];
// const jobTypes      = ["All Types","Full-Time","Part-Time","Contract","Internship"];
// const experienceLvl = ["All Experience","0-2 Years","2-5 Years","5-10 Years","10+ Years"];
// const locations     = ["All Locations","Mumbai","Pune","Delhi","Bengaluru","Hyderabad","Chennai","Ahmedabad","Thrissur","Gurugram"];

// const industryIcons = {
//   "All Industries":"🏥", Doctor:"👨‍⚕️", Dentist:"🦷",
//   Physiotherapy:"🏃", Nurse:"👩‍⚕️", Paramedical:"🚑", Ayurveda:"🌿",
// };

// /* ─── styles (same as original, unchanged) ─── */
// const styles = `
//   @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700;800;900&family=Poppins:wght@400;500;600;700&display=swap');
//   *{box-sizing:border-box;margin:0;padding:0;}
//   .jp-root{font-family:'Nunito',sans-serif;background:#f0f7f9;min-height:100vh;color:#1a3a4a;}
//   .jp-hero{background:linear-gradient(135deg,#0d7377 0%,#14a085 40%,#1a8c8c 70%,#0a5f6e 100%);padding:56px 32px 44px;position:relative;overflow:hidden;}
//   .jp-hero::before{content:'';position:absolute;top:-60px;right:-60px;width:300px;height:300px;border-radius:50%;background:rgba(255,255,255,.05);}
//   .jp-hero::after{content:'';position:absolute;bottom:-80px;left:-80px;width:400px;height:400px;border-radius:50%;background:rgba(255,255,255,.04);}
//   .jp-hero-inner{max-width:1200px;margin:0 auto;position:relative;z-index:1;}
//   .jp-hero h1{font-family:'Poppins',sans-serif;font-size:2.4rem;font-weight:700;color:#fff;margin-bottom:8px;letter-spacing:-.5px;}
//   .jp-hero h1 span{color:#b8f0e0;}
//   .jp-hero p{color:rgba(255,255,255,.82);font-size:1.05rem;margin-bottom:28px;}
//   .jp-search-bar{display:flex;gap:10px;background:rgba(255,255,255,.15);backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.25);border-radius:16px;padding:8px 8px 8px 20px;align-items:center;max-width:780px;}
//   .jp-search-bar input{flex:1;background:transparent;border:none;outline:none;color:#fff;font-family:'Nunito',sans-serif;font-size:1rem;font-weight:500;}
//   .jp-search-bar input::placeholder{color:rgba(255,255,255,.6);}
//   .jp-search-btn{background:#fff;color:#0d7377;border:none;border-radius:10px;padding:10px 24px;font-family:'Poppins',sans-serif;font-weight:600;font-size:.95rem;cursor:pointer;transition:all .2s;white-space:nowrap;}
//   .jp-search-btn:hover{background:#e0f7f3;transform:translateY(-1px);}
//   .jp-stats{display:flex;gap:28px;margin-top:24px;flex-wrap:wrap;}
//   .jp-stat{display:flex;align-items:center;gap:8px;color:rgba(255,255,255,.85);font-size:.9rem;font-weight:600;}
//   .jp-stat-num{color:#b8f0e0;font-size:1.1rem;font-weight:800;}
//   .jp-industry-bar{background:#fff;border-bottom:1px solid #d9eef0;padding:0 32px;overflow-x:auto;scrollbar-width:none;}
//   .jp-industry-bar::-webkit-scrollbar{display:none;}
//   .jp-industry-inner{max-width:1200px;margin:0 auto;display:flex;gap:4px;padding:12px 0;}
//   .jp-ind-btn{display:flex;align-items:center;gap:7px;padding:9px 18px;border-radius:30px;border:1.5px solid #c5e5e8;background:#f5fcfd;color:#2a7a82;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;white-space:nowrap;}
//   .jp-ind-btn:hover{background:#e0f5f5;border-color:#0d7377;color:#0d7377;}
//   .jp-ind-btn.active{background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border-color:transparent;box-shadow:0 4px 14px rgba(13,115,119,.3);}
//   .jp-ind-icon{font-size:1.1rem;}
//   .jp-main{max-width:1200px;margin:0 auto;padding:28px 32px;display:grid;grid-template-columns:280px 1fr;gap:24px;align-items:start;}
//   .jp-sidebar{background:#fff;border-radius:18px;padding:22px;border:1px solid #d5eef0;position:sticky;top:16px;box-shadow:0 4px 20px rgba(13,115,119,.06);}
//   .jp-sidebar-title{font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;color:#0d7377;margin-bottom:18px;display:flex;align-items:center;gap:8px;}
//   .jp-filter-group{margin-bottom:20px;}
//   .jp-filter-label{font-weight:700;font-size:.82rem;color:#4a7a82;text-transform:uppercase;letter-spacing:.08em;margin-bottom:10px;}
//   .jp-filter-select{width:100%;padding:10px 14px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.92rem;color:#1a3a4a;background:#f5fcfd;outline:none;cursor:pointer;transition:border-color .2s;}
//   .jp-filter-select:focus{border-color:#0d7377;}
//   .jp-checkbox-group{display:flex;flex-direction:column;gap:8px;}
//   .jp-checkbox-item{display:flex;align-items:center;gap:9px;font-size:.9rem;color:#2a4a55;cursor:pointer;font-weight:600;}
//   .jp-checkbox-item input[type=checkbox]{width:16px;height:16px;accent-color:#0d7377;cursor:pointer;}
//   .jp-filter-divider{border:none;border-top:1px solid #e0f0f2;margin:16px 0;}
//   .jp-clear-btn{width:100%;padding:10px;border-radius:10px;border:1.5px solid #0d7377;background:transparent;color:#0d7377;font-family:'Nunito',sans-serif;font-weight:700;font-size:.9rem;cursor:pointer;transition:all .2s;}
//   .jp-clear-btn:hover{background:#e0f7f3;}
//   .jp-listings{display:flex;flex-direction:column;gap:16px;}
//   .jp-top-bar{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;flex-wrap:wrap;gap:12px;}
//   .jp-count{font-weight:700;color:#2a5a64;font-size:1rem;}
//   .jp-count span{color:#0d7377;}
//   .jp-sort-select{padding:8px 14px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.88rem;color:#1a3a4a;background:#fff;outline:none;cursor:pointer;}
//   .jp-card{background:#fff;border-radius:18px;border:1.5px solid #d5eef0;padding:22px 24px;cursor:pointer;transition:all .25s;position:relative;box-shadow:0 2px 12px rgba(13,115,119,.04);}
//   .jp-card:hover{border-color:#0d7377;box-shadow:0 8px 28px rgba(13,115,119,.13);transform:translateY(-2px);}
//   .jp-card.featured{border-color:#14a085;}
//   .jp-card-badges{position:absolute;top:18px;right:20px;display:flex;gap:6px;}
//   .jp-badge{padding:4px 11px;border-radius:20px;font-size:.73rem;font-weight:800;text-transform:uppercase;letter-spacing:.04em;}
//   .jp-badge-featured{background:#e0f7f0;color:#0d7377;border:1px solid #b0e8da;}
//   .jp-badge-urgent{background:#fff0e8;color:#d4631a;border:1px solid #fad0b0;}
//   .jp-card-header{display:flex;gap:16px;align-items:flex-start;}
//   .jp-card-logo{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e8f8f5,#d0efed);display:flex;align-items:center;justify-content:center;font-size:1.8rem;flex-shrink:0;border:1px solid #c0e8e4;}
//   .jp-card-info{flex:1;}
//   .jp-card-title{font-family:'Poppins',sans-serif;font-weight:600;font-size:1.1rem;color:#0d4a55;margin-bottom:3px;padding-right:120px;line-height:1.3;}
//   .jp-card-company{color:#0d7377;font-weight:700;font-size:.93rem;margin-bottom:10px;}
//   .jp-card-meta{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:14px;}
//   .jp-meta-item{display:flex;align-items:center;gap:5px;font-size:.85rem;color:#4a7a82;font-weight:600;}
//   .jp-meta-icon{font-size:.95rem;}
//   .jp-card-tags{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:14px;}
//   .jp-tag{padding:4px 12px;background:#f0fafc;border:1px solid #c8e8ec;border-radius:20px;font-size:.8rem;color:#2a6a72;font-weight:700;}
//   .jp-card-footer{display:flex;justify-content:space-between;align-items:center;padding-top:14px;border-top:1px solid #eaf5f6;flex-wrap:wrap;gap:10px;}
//   .jp-salary{font-family:'Poppins',sans-serif;font-weight:700;font-size:1rem;color:#0d7377;}
//   .jp-card-actions{display:flex;gap:9px;}
//   .jp-btn-apply{padding:9px 22px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border:none;border-radius:10px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 12px rgba(13,115,119,.25);}
//   .jp-btn-apply:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(13,115,119,.35);}
//   .jp-btn-save{padding:9px 16px;background:#f0fafc;color:#0d7377;border:1.5px solid #c0e0e4;border-radius:10px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;}
//   .jp-btn-save:hover{background:#e0f7f3;border-color:#0d7377;}
//   .jp-posted{font-size:.8rem;color:#8aacb2;font-weight:600;}
//   .jp-no-results{background:#fff;border-radius:18px;padding:60px 32px;text-align:center;border:1.5px dashed #c5e5e8;}
//   .jp-no-results-icon{font-size:3rem;margin-bottom:16px;}
//   .jp-no-results h3{color:#0d4a55;font-size:1.2rem;margin-bottom:8px;}
//   .jp-no-results p{color:#6a9aa2;font-size:.95rem;}
//   .jp-loading{text-align:center;padding:60px;color:#5a8a94;font-size:1rem;}
//   .jp-modal-overlay{position:fixed;inset:0;background:rgba(5,30,40,.55);backdrop-filter:blur(4px);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;}
//   .jp-modal{background:#fff;border-radius:22px;max-width:680px;width:100%;max-height:88vh;overflow-y:auto;box-shadow:0 24px 60px rgba(13,115,119,.2);}
//   .jp-modal-header{background:linear-gradient(135deg,#0d7377,#14a085);padding:28px 28px 24px;border-radius:22px 22px 0 0;position:relative;}
//   .jp-modal-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.2);border:none;color:#fff;font-size:1.1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s;}
//   .jp-modal-close:hover{background:rgba(255,255,255,.35);}
//   .jp-modal-logo{width:64px;height:64px;border-radius:16px;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:2rem;margin-bottom:14px;border:1.5px solid rgba(255,255,255,.3);}
//   .jp-modal-title{font-family:'Poppins',sans-serif;font-weight:700;font-size:1.4rem;color:#fff;margin-bottom:4px;}
//   .jp-modal-company{color:rgba(255,255,255,.85);font-weight:700;font-size:1rem;}
//   .jp-modal-body{padding:28px;}
//   .jp-modal-meta-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:24px;}
//   .jp-modal-meta-card{background:#f4fbfc;border:1px solid #d0ecee;border-radius:12px;padding:12px 14px;}
//   .jp-modal-meta-card-label{font-size:.75rem;color:#6a9aa2;font-weight:700;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;}
//   .jp-modal-meta-card-value{font-weight:700;color:#0d4a55;font-size:.95rem;}
//   .jp-modal-section{margin-bottom:20px;}
//   .jp-modal-section h4{font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;color:#0d7377;margin-bottom:10px;display:flex;align-items:center;gap:7px;}
//   .jp-modal-section p{color:#3a5a64;font-size:.95rem;line-height:1.65;}
//   .jp-modal-list{list-style:none;display:flex;flex-direction:column;gap:7px;}
//   .jp-modal-list li{display:flex;align-items:flex-start;gap:8px;color:#3a5a64;font-size:.92rem;font-weight:600;}
//   .jp-modal-list li::before{content:'✓';color:#0d7377;font-weight:800;flex-shrink:0;}
//   .jp-modal-footer{padding:20px 28px 28px;display:flex;gap:12px;border-top:1px solid #eaf5f6;}
//   .jp-btn-apply-lg{flex:1;padding:14px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border:none;border-radius:12px;font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;cursor:pointer;transition:all .2s;box-shadow:0 6px 18px rgba(13,115,119,.3);}
//   .jp-btn-apply-lg:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(13,115,119,.38);}
//   .jp-btn-save-lg{padding:14px 20px;background:#f0fafc;color:#0d7377;border:1.5px solid #c0e0e4;border-radius:12px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.95rem;cursor:pointer;transition:all .2s;}
//   .jp-btn-save-lg:hover{background:#e0f7f3;}
//   .jp-pagination{display:flex;justify-content:center;gap:8px;margin-top:10px;}
//   .jp-page-btn{width:38px;height:38px;border-radius:10px;border:1.5px solid #c5e5e8;background:#fff;color:#0d7377;font-weight:700;font-size:.9rem;cursor:pointer;transition:all .2s;display:flex;align-items:center;justify-content:center;}
//   .jp-page-btn:hover,.jp-page-btn.active{background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border-color:transparent;box-shadow:0 4px 12px rgba(13,115,119,.25);}
//   .jp-toast{position:fixed;bottom:28px;right:28px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;padding:14px 22px;border-radius:12px;font-weight:700;font-size:.92rem;z-index:2000;box-shadow:0 8px 24px rgba(13,115,119,.35);animation:slideIn .3s ease;display:flex;align-items:center;gap:9px;}
//   @keyframes slideIn{from{transform:translateX(80px);opacity:0}to{transform:translateX(0);opacity:1}}
//   @media(max-width:900px){
//     .jp-main{grid-template-columns:1fr;padding:20px 16px;}
//     .jp-sidebar{position:static;}
//     .jp-hero{padding:36px 20px 32px;}
//     .jp-hero h1{font-size:1.7rem;}
//     .jp-card-title{padding-right:80px;}
//     .jp-modal-meta-grid{grid-template-columns:1fr;}
//   }
// `;





// export default function JobPost() {
//   const [allJobs, setAllJobs]               = useState([]);
//   const [loadingJobs, setLoadingJobs]       = useState(true);
//   const [search, setSearch]                 = useState("");
//   const [industry, setIndustry]             = useState("All Industries");
//   const [jobType, setJobType]               = useState("All Types");
//   const [experience, setExperience]         = useState("All Experience");
//   const [location, setLocation]             = useState("All Locations");
//   const [sortBy, setSortBy]                 = useState("Newest First");
//   const [featuredOnly, setFeaturedOnly]     = useState(false);
//   const [urgentOnly, setUrgentOnly]         = useState(false);
//   const [selectedJob, setSelectedJob]       = useState(null);
//   const [savedJobs, setSavedJobs]           = useState([]);
//   const [toast, setToast]                   = useState(null);
//   const [page, setPage]                     = useState(1);
//   const [showAuthModal, setShowAuthModal]   = useState(false);  // ← NEW
//   const [pendingJob, setPendingJob]         = useState(null);   // ← NEW
//   const PER_PAGE = 5;

//   // ── Fetch all jobs from every doctor in Firebase ──
//   useEffect(() => {
//     const db = getDatabase(app);
//     const timer = setTimeout(() => setLoadingJobs(false), 8000);

//     const unsub = onValue(
//       ref(db, "jobs"),
//       (snap) => {
//         clearTimeout(timer);
//         if (snap.exists()) {
//           const data = snap.val();
//           const flat = [];
//           Object.values(data).forEach((doctorJobs) => {
//             if (doctorJobs && typeof doctorJobs === "object") {
//               Object.values(doctorJobs).forEach((job) => {
//                 if (job && typeof job === "object") flat.push(job);
//               });
//             }
//           });
//           flat.sort((a, b) => new Date(b.postedAt || 0) - new Date(a.postedAt || 0));
//           setAllJobs(flat);
//         } else {
//           setAllJobs([]);
//         }
//         setLoadingJobs(false);
//       },
//       (error) => {
//         clearTimeout(timer);
//         console.error("Firebase jobs read error:", error);
//         setAllJobs([]);
//         setLoadingJobs(false);
//       }
//     );
//     return () => { unsub(); clearTimeout(timer); };
//   }, []);

//   const showToast = (msg, icon = "✅") => {
//     setToast({ msg, icon });
//     setTimeout(() => setToast(null), 2800);
//   };

//   const toggleSave = (e, jobId) => {
//     e.stopPropagation();
//     setSavedJobs((prev) =>
//       prev.includes(jobId) ? prev.filter((id) => id !== jobId) : [...prev, jobId]
//     );
//     showToast(savedJobs.includes(jobId) ? "Job removed from saved" : "Job saved!", "💾");
//   };

//   // ── Opens the auth modal, remembering which job was clicked ──
//   const handleApplyClick = (e, job) => {
//     e.stopPropagation();
//     setPendingJob(job);
//     setShowAuthModal(true);
//   };

//   // ── Called by AuthModal after successful login/register ──
//   const handleAuthSuccess = () => {
//     setShowAuthModal(false);
//     if (pendingJob) {
//       showToast(`Applied to ${pendingJob.title}!`, "🎉");
//       setPendingJob(null);
//     }
//   };

//   const filtered = allJobs.filter((job) => {
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (job.title || "").toLowerCase().includes(q) ||
//       (job.company || "").toLowerCase().includes(q) ||
//       (job.specialty || "").toLowerCase().includes(q) ||
//       (Array.isArray(job.skills) ? job.skills : []).some((s) => s.toLowerCase().includes(q));
//     const matchIndustry  = industry === "All Industries" || job.industry === industry;
//     const matchType      = jobType === "All Types" || job.type === jobType;
//     const matchLocation  = location === "All Locations" || (job.location || "").toLowerCase().includes(location.toLowerCase());
//     const matchFeatured  = !featuredOnly || job.featured;
//     const matchUrgent    = !urgentOnly || job.urgent;
//     return matchSearch && matchIndustry && matchType && matchLocation && matchFeatured && matchUrgent;
//   });

//   const sorted = [...filtered].sort((a, b) => {
//     if (sortBy === "Salary High-Low") return 0;
//     if (sortBy === "Featured First") return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
//     return new Date(b.postedAt || 0) - new Date(a.postedAt || 0);
//   });

//   const totalPages = Math.ceil(sorted.length / PER_PAGE);
//   const paginated  = sorted.slice((page - 1) * PER_PAGE, page * PER_PAGE);

//   useEffect(() => { setPage(1); }, [search, industry, jobType, location, featuredOnly, urgentOnly]);

//   // Format posted date from ISO string → "2 days ago" style
//   const relativeDate = (iso) => {
//     if (!iso) return "";
//     const diff = Date.now() - new Date(iso).getTime();
//     const mins  = Math.floor(diff / 60000);
//     const hours = Math.floor(diff / 3600000);
//     const days  = Math.floor(diff / 86400000);
//     if (mins  < 60)  return `${mins} min${mins !== 1 ? "s" : ""} ago`;
//     if (hours < 24)  return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//     if (days  <  7)  return `${days} day${days !== 1 ? "s" : ""} ago`;
//     return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
//   };

//   return (
//     <>
//       <style>{styles}</style>
//       <div className="jp-root">

//         {/* Hero */}
//         <div className="jp-hero">
//           <div className="jp-hero-inner">
//             <h1>Healthcare <span>Job Portal</span></h1>
//             <p>Find top medical careers posted by clinics & hospitals across India</p>
//             <div className="jp-search-bar">
//               <span>🔍</span>
//               <AutosuggestInput
//                 value={search}
//                 onChange={(val) => setSearch(val)}
//                 placeholder="Search by job title, specialty, company or skill..."
//                 inputStyle={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#fff", fontFamily: "'Nunito', sans-serif", fontSize: "1rem", fontWeight: 500 }}
//                 limit={6}
//               />
//               <button className="jp-search-btn">Search Jobs</button>
//             </div>
//             <div className="jp-stats">
//               <div className="jp-stat"><span className="jp-stat-num">{allJobs.length}</span> Live Jobs</div>
//               <div className="jp-stat"><span className="jp-stat-num">{allJobs.filter(j=>j.featured).length}</span> Featured</div>
//               <div className="jp-stat"><span className="jp-stat-num">{allJobs.filter(j=>j.urgent).length}</span> Urgent Hiring</div>
//               <div className="jp-stat"><span className="jp-stat-num">6</span> Specialties</div>
//             </div>
//           </div>
//         </div>

//         {/* Industry Quick Filters */}
//         <div className="jp-industry-bar">
//           <div className="jp-industry-inner">
//             {industries.map((ind) => (
//               <button
//                 key={ind}
//                 className={`jp-ind-btn ${industry === ind ? "active" : ""}`}
//                 onClick={() => setIndustry(ind)}
//               >
//                 <span className="jp-ind-icon">{industryIcons[ind]}</span>
//                 {ind}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Main */}
//         <div className="jp-main">

//           {/* Sidebar */}
//           <div className="jp-sidebar">
//             <div className="jp-sidebar-title">🔧 Filter Jobs</div>
//             <div className="jp-filter-group">
//               <div className="jp-filter-label">Job Type</div>
//               <select className="jp-filter-select" value={jobType} onChange={(e) => setJobType(e.target.value)}>
//                 {jobTypes.map((t) => <option key={t}>{t}</option>)}
//               </select>
//             </div>
//             <div className="jp-filter-group">
//               <div className="jp-filter-label">Location</div>
//               <select className="jp-filter-select" value={location} onChange={(e) => setLocation(e.target.value)}>
//                 {locations.map((l) => <option key={l}>{l}</option>)}
//               </select>
//             </div>
//             <div className="jp-filter-group">
//               <div className="jp-filter-label">Experience</div>
//               <select className="jp-filter-select" value={experience} onChange={(e) => setExperience(e.target.value)}>
//                 {experienceLvl.map((e) => <option key={e}>{e}</option>)}
//               </select>
//             </div>
//             <hr className="jp-filter-divider"/>
//             <div className="jp-filter-group">
//               <div className="jp-filter-label">Special Filters</div>
//               <div className="jp-checkbox-group">
//                 <label className="jp-checkbox-item">
//                   <input type="checkbox" checked={featuredOnly} onChange={(e) => setFeaturedOnly(e.target.checked)}/>
//                   ⭐ Featured Jobs Only
//                 </label>
//                 <label className="jp-checkbox-item">
//                   <input type="checkbox" checked={urgentOnly} onChange={(e) => setUrgentOnly(e.target.checked)}/>
//                   🔴 Urgent Hiring Only
//                 </label>
//               </div>
//             </div>
//             <hr className="jp-filter-divider"/>
//             <button className="jp-clear-btn" onClick={() => {
//               setSearch(""); setIndustry("All Industries"); setJobType("All Types");
//               setLocation("All Locations"); setExperience("All Experience");
//               setFeaturedOnly(false); setUrgentOnly(false);
//             }}>
//               Clear All Filters
//             </button>
//           </div>

//           {/* Listings */}
//           <div className="jp-listings">
//             <div className="jp-top-bar">
//               <div className="jp-count">
//                 Showing <span>{filtered.length}</span> job{filtered.length !== 1 ? "s" : ""}
//                 {industry !== "All Industries" ? ` in ${industry}` : ""}
//               </div>
//               <select className="jp-sort-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
//                 <option>Newest First</option>
//                 <option>Salary High-Low</option>
//                 <option>Featured First</option>
//               </select>
//             </div>

//             {loadingJobs ? (
//               <div className="jp-loading">⏳ Loading live jobs…</div>
//             ) : paginated.length === 0 ? (
//               <div className="jp-no-results">
//                 <div className="jp-no-results-icon">🔍</div>
//                 <h3>{allJobs.length === 0 ? "No jobs posted yet" : "No jobs found"}</h3>
//                 <p>
//                   {allJobs.length === 0
//                     ? "Doctors can post jobs from their dashboard. Check back soon!"
//                     : "Try adjusting your search or filters to find matching opportunities."}
//                 </p>
//               </div>
//             ) : (
//               paginated.map((job) => (
//                 <div
//                   key={job.id || job.postedAt}
//                   className={`jp-card ${job.featured ? "featured" : ""}`}
//                   onClick={() => setSelectedJob(job)}
//                 >
//                   <div className="jp-card-badges">
//                     {job.featured && <span className="jp-badge jp-badge-featured">⭐ Featured</span>}
//                     {job.urgent   && <span className="jp-badge jp-badge-urgent">🔴 Urgent</span>}
//                   </div>
//                   <div className="jp-card-header">
//                     <div className="jp-card-logo">{job.logo || "🏥"}</div>
//                     <div className="jp-card-info">
//                       <div className="jp-card-title">{job.title}</div>
//                       <div className="jp-card-company">{job.company}</div>
//                       <div className="jp-card-meta">
//                         <span className="jp-meta-item"><span className="jp-meta-icon">📍</span>{job.location}</span>
//                         <span className="jp-meta-item"><span className="jp-meta-icon">💼</span>{job.type}</span>
//                         <span className="jp-meta-item"><span className="jp-meta-icon">⏱</span>{job.experience}</span>
//                         <span className="jp-meta-item"><span className="jp-meta-icon">🏷</span>{job.specialty}</span>
//                       </div>
//                       <div className="jp-card-tags">
//                         {(Array.isArray(job.skills) ? job.skills : []).map((s) => (
//                           <span key={s} className="jp-tag">{s}</span>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="jp-card-footer">
//                     <div>
//                       <div className="jp-salary">{job.salary || "Not disclosed"}</div>
//                       <div className="jp-posted">Posted {relativeDate(job.postedAt) || job.posted}</div>
//                     </div>
//                     <div className="jp-card-actions">
//                       <button className="jp-btn-save" onClick={(e) => toggleSave(e, job.id || job.postedAt)}>
//                         {savedJobs.includes(job.id || job.postedAt) ? "💙 Saved" : "🤍 Save"}
//                       </button>
//                       {/* ── UPDATED: opens AuthModal instead of toast ── */}
//                       <button
//                         className="jp-btn-apply"
//                         onClick={(e) => handleApplyClick(e, job)}
//                       >
//                         Apply Now →
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             )}

//             {totalPages > 1 && (
//               <div className="jp-pagination">
//                 <button className="jp-page-btn" onClick={() => setPage((p) => Math.max(1, p - 1))}>‹</button>
//                 {Array.from({ length: totalPages }, (_, i) => (
//                   <button
//                     key={i + 1}
//                     className={`jp-page-btn ${page === i + 1 ? "active" : ""}`}
//                     onClick={() => setPage(i + 1)}
//                   >
//                     {i + 1}
//                   </button>
//                 ))}
//                 <button className="jp-page-btn" onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>›</button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Job Detail Modal */}
//         {selectedJob && (
//           <div className="jp-modal-overlay" onClick={() => setSelectedJob(null)}>
//             <div className="jp-modal" onClick={(e) => e.stopPropagation()}>
//               <div className="jp-modal-header">
//                 <button className="jp-modal-close" onClick={() => setSelectedJob(null)}>✕</button>
//                 <div className="jp-modal-logo">{selectedJob.logo || "🏥"}</div>
//                 <div className="jp-modal-title">{selectedJob.title}</div>
//                 <div className="jp-modal-company">{selectedJob.company}</div>
//               </div>
//               <div className="jp-modal-body">
//                 <div className="jp-modal-meta-grid">
//                   {[
//                     { label:"Location",   value:selectedJob.location,   icon:"📍" },
//                     { label:"Job Type",   value:selectedJob.type,        icon:"💼" },
//                     { label:"Experience", value:selectedJob.experience,  icon:"⏱" },
//                     { label:"Salary",     value:selectedJob.salary,      icon:"💰" },
//                     { label:"Industry",   value:selectedJob.industry,    icon:"🏥" },
//                     { label:"Specialty",  value:selectedJob.specialty,   icon:"🔬" },
//                     { label:"Posted",     value:relativeDate(selectedJob.postedAt) || selectedJob.posted, icon:"📅" },
//                     { label:"Deadline",   value:selectedJob.deadline || "Not specified", icon:"⏰" },
//                   ].map((m) => (
//                     <div key={m.label} className="jp-modal-meta-card">
//                       <div className="jp-modal-meta-card-label">{m.icon} {m.label}</div>
//                       <div className="jp-modal-meta-card-value">{m.value}</div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="jp-modal-section">
//                   <h4>📋 Job Description</h4>
//                   <p>{selectedJob.description}</p>
//                 </div>
//                 {selectedJob.requirements?.length > 0 && (
//                   <div className="jp-modal-section">
//                     <h4>✅ Requirements</h4>
//                     <ul className="jp-modal-list">
//                       {(Array.isArray(selectedJob.requirements)
//                         ? selectedJob.requirements
//                         : selectedJob.requirements.split("\n")
//                       ).map((r, i) => r && <li key={i}>{r}</li>)}
//                     </ul>
//                   </div>
//                 )}
//                 {selectedJob.skills?.length > 0 && (
//                   <div className="jp-modal-section">
//                     <h4>🛠 Key Skills</h4>
//                     <div className="jp-card-tags">
//                       {(Array.isArray(selectedJob.skills) ? selectedJob.skills : []).map((s) => (
//                         <span key={s} className="jp-tag">{s}</span>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="jp-modal-footer">
//                 {/* ── UPDATED: opens AuthModal, closes job detail modal ── */}
//                 <button
//                   className="jp-btn-apply-lg"
//                   onClick={(e) => {
//                     setSelectedJob(null);
//                     handleApplyClick(e, selectedJob);
//                   }}
//                 >
//                   Apply for This Job →
//                 </button>
//                 <button
//                   className="jp-btn-save-lg"
//                   onClick={(e) => toggleSave(e, selectedJob.id || selectedJob.postedAt)}
//                 >
//                   {savedJobs.includes(selectedJob.id || selectedJob.postedAt) ? "💙 Saved" : "🤍 Save Job"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ── Auth Modal (role picker → login / register) ── */}
//         {showAuthModal && (
//           <AuthModal
//             job={pendingJob}
//             onClose={() => { setShowAuthModal(false); setPendingJob(null); }}
//             onSuccess={handleAuthSuccess}
//           />
//         )}

//         {/* Toast */}
//         {toast && (
//           <div className="jp-toast">
//             <span>{toast.icon}</span>
//             {toast.msg}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

import { useState, useEffect } from "react";
import AutosuggestInput from "../Doctor/DashboardDr/dashpages/AutosuggestInput";
import { onValue, ref, getDatabase } from "firebase/database";
import { app } from "../../src/Doctor/Firebase/firebase.config";
import AuthModal from "./AuthModal";

/* ─── static filter options ─── */
const industries    = ["All Industries","Doctor","Dentist","Physiotherapy","Nurse","Paramedical","Ayurveda"];
const jobTypes      = ["All Types","Full-Time","Part-Time","Contract","Internship"];
const experienceLvl = ["All Experience","0-2 Years","2-5 Years","5-10 Years","10+ Years"];
const locations     = ["All Locations","Mumbai","Pune","Delhi","Bengaluru","Hyderabad","Chennai","Ahmedabad","Thrissur","Gurugram"];

const industryIcons = {
  "All Industries":"🏥", Doctor:"👨‍⚕️", Dentist:"🦷",
  Physiotherapy:"🏃", Nurse:"👩‍⚕️", Paramedical:"🚑", Ayurveda:"🌿",
};

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700;800;900&family=Poppins:wght@400;500;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  .jp-root{font-family:'Nunito',sans-serif;background:#f0f7f9;min-height:100vh;color:#1a3a4a;}
  .jp-hero{background:linear-gradient(135deg,#0d7377 0%,#14a085 40%,#1a8c8c 70%,#0a5f6e 100%);padding:56px 32px 44px;position:relative;overflow:hidden;}
  .jp-hero::before{content:'';position:absolute;top:-60px;right:-60px;width:300px;height:300px;border-radius:50%;background:rgba(255,255,255,.05);}
  .jp-hero::after{content:'';position:absolute;bottom:-80px;left:-80px;width:400px;height:400px;border-radius:50%;background:rgba(255,255,255,.04);}
  .jp-hero-inner{max-width:1200px;margin:0 auto;position:relative;z-index:1;}
  .jp-hero h1{font-family:'Poppins',sans-serif;font-size:2.4rem;font-weight:700;color:#fff;margin-bottom:8px;letter-spacing:-.5px;}
  .jp-hero h1 span{color:#b8f0e0;}
  .jp-hero p{color:rgba(255,255,255,.82);font-size:1.05rem;margin-bottom:28px;}
  .jp-search-bar{display:flex;gap:10px;background:rgba(255,255,255,.15);backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.25);border-radius:16px;padding:8px 8px 8px 20px;align-items:center;max-width:780px;}
  .jp-search-bar input{flex:1;background:transparent;border:none;outline:none;color:#fff;font-family:'Nunito',sans-serif;font-size:1rem;font-weight:500;}
  .jp-search-bar input::placeholder{color:rgba(255,255,255,.6);}
  .jp-search-btn{background:#fff;color:#0d7377;border:none;border-radius:10px;padding:10px 24px;font-family:'Poppins',sans-serif;font-weight:600;font-size:.95rem;cursor:pointer;transition:all .2s;white-space:nowrap;}
  .jp-search-btn:hover{background:#e0f7f3;transform:translateY(-1px);}
  .jp-stats{display:flex;gap:28px;margin-top:24px;flex-wrap:wrap;}
  .jp-stat{display:flex;align-items:center;gap:8px;color:rgba(255,255,255,.85);font-size:.9rem;font-weight:600;}
  .jp-stat-num{color:#b8f0e0;font-size:1.1rem;font-weight:800;}
  .jp-industry-bar{background:#fff;border-bottom:1px solid #d9eef0;padding:0 32px;overflow-x:auto;scrollbar-width:none;}
  .jp-industry-bar::-webkit-scrollbar{display:none;}
  .jp-industry-inner{max-width:1200px;margin:0 auto;display:flex;gap:4px;padding:12px 0;}
  .jp-ind-btn{display:flex;align-items:center;gap:7px;padding:9px 18px;border-radius:30px;border:1.5px solid #c5e5e8;background:#f5fcfd;color:#2a7a82;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;white-space:nowrap;}
  .jp-ind-btn:hover{background:#e0f5f5;border-color:#0d7377;color:#0d7377;}
  .jp-ind-btn.active{background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border-color:transparent;box-shadow:0 4px 14px rgba(13,115,119,.3);}
  .jp-ind-icon{font-size:1.1rem;}
  .jp-main{max-width:1200px;margin:0 auto;padding:28px 32px;display:grid;grid-template-columns:280px 1fr;gap:24px;align-items:start;}
  .jp-sidebar{background:#fff;border-radius:18px;padding:22px;border:1px solid #d5eef0;position:sticky;top:16px;box-shadow:0 4px 20px rgba(13,115,119,.06);}
  .jp-sidebar-title{font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;color:#0d7377;margin-bottom:18px;display:flex;align-items:center;gap:8px;}
  .jp-filter-group{margin-bottom:20px;}
  .jp-filter-label{font-weight:700;font-size:.82rem;color:#4a7a82;text-transform:uppercase;letter-spacing:.08em;margin-bottom:10px;}
  .jp-filter-select{width:100%;padding:10px 14px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.92rem;color:#1a3a4a;background:#f5fcfd;outline:none;cursor:pointer;transition:border-color .2s;}
  .jp-filter-select:focus{border-color:#0d7377;}
  .jp-checkbox-group{display:flex;flex-direction:column;gap:8px;}
  .jp-checkbox-item{display:flex;align-items:center;gap:9px;font-size:.9rem;color:#2a4a55;cursor:pointer;font-weight:600;}
  .jp-checkbox-item input[type=checkbox]{width:16px;height:16px;accent-color:#0d7377;cursor:pointer;}
  .jp-filter-divider{border:none;border-top:1px solid #e0f0f2;margin:16px 0;}
  .jp-clear-btn{width:100%;padding:10px;border-radius:10px;border:1.5px solid #0d7377;background:transparent;color:#0d7377;font-family:'Nunito',sans-serif;font-weight:700;font-size:.9rem;cursor:pointer;transition:all .2s;}
  .jp-clear-btn:hover{background:#e0f7f3;}
  .jp-listings{display:flex;flex-direction:column;gap:16px;}
  .jp-top-bar{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;flex-wrap:wrap;gap:12px;}
  .jp-count{font-weight:700;color:#2a5a64;font-size:1rem;}
  .jp-count span{color:#0d7377;}
  .jp-sort-select{padding:8px 14px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.88rem;color:#1a3a4a;background:#fff;outline:none;cursor:pointer;}
  .jp-card{background:#fff;border-radius:18px;border:1.5px solid #d5eef0;padding:22px 24px;cursor:pointer;transition:all .25s;position:relative;box-shadow:0 2px 12px rgba(13,115,119,.04);}
  .jp-card:hover{border-color:#0d7377;box-shadow:0 8px 28px rgba(13,115,119,.13);transform:translateY(-2px);}
  .jp-card.featured{border-color:#14a085;}
  .jp-card-badges{position:absolute;top:18px;right:20px;display:flex;gap:6px;}
  .jp-badge{padding:4px 11px;border-radius:20px;font-size:.73rem;font-weight:800;text-transform:uppercase;letter-spacing:.04em;}
  .jp-badge-featured{background:#e0f7f0;color:#0d7377;border:1px solid #b0e8da;}
  .jp-badge-urgent{background:#fff0e8;color:#d4631a;border:1px solid #fad0b0;}
  .jp-card-header{display:flex;gap:16px;align-items:flex-start;}
  .jp-card-logo{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e8f8f5,#d0efed);display:flex;align-items:center;justify-content:center;font-size:1.8rem;flex-shrink:0;border:1px solid #c0e8e4;}
  .jp-card-info{flex:1;}
  .jp-card-title{font-family:'Poppins',sans-serif;font-weight:600;font-size:1.1rem;color:#0d4a55;margin-bottom:10px;padding-right:120px;line-height:1.3;}
  .jp-card-meta{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:14px;}
  .jp-meta-item{display:flex;align-items:center;gap:5px;font-size:.85rem;color:#4a7a82;font-weight:600;}
  .jp-meta-icon{font-size:.95rem;}
  .jp-card-tags{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:14px;}
  .jp-tag{padding:4px 12px;background:#f0fafc;border:1px solid #c8e8ec;border-radius:20px;font-size:.8rem;color:#2a6a72;font-weight:700;}
  .jp-card-footer{display:flex;justify-content:space-between;align-items:center;padding-top:14px;border-top:1px solid #eaf5f6;flex-wrap:wrap;gap:10px;}
  .jp-card-actions{display:flex;gap:9px;}
  .jp-btn-apply{padding:9px 22px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border:none;border-radius:10px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 12px rgba(13,115,119,.25);}
  .jp-btn-apply:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(13,115,119,.35);}
  .jp-btn-save{padding:9px 16px;background:#f0fafc;color:#0d7377;border:1.5px solid #c0e0e4;border-radius:10px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.88rem;cursor:pointer;transition:all .2s;}
  .jp-btn-save:hover{background:#e0f7f3;border-color:#0d7377;}
  .jp-posted{font-size:.8rem;color:#8aacb2;font-weight:600;}
  .jp-no-results{background:#fff;border-radius:18px;padding:60px 32px;text-align:center;border:1.5px dashed #c5e5e8;}
  .jp-no-results-icon{font-size:3rem;margin-bottom:16px;}
  .jp-no-results h3{color:#0d4a55;font-size:1.2rem;margin-bottom:8px;}
  .jp-no-results p{color:#6a9aa2;font-size:.95rem;}
  .jp-loading{text-align:center;padding:60px;color:#5a8a94;font-size:1rem;}
  .jp-modal-overlay{position:fixed;inset:0;background:rgba(5,30,40,.55);backdrop-filter:blur(4px);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;}
  .jp-modal{background:#fff;border-radius:22px;max-width:680px;width:100%;max-height:88vh;overflow-y:auto;box-shadow:0 24px 60px rgba(13,115,119,.2);}
  .jp-modal-header{background:linear-gradient(135deg,#0d7377,#14a085);padding:28px 28px 24px;border-radius:22px 22px 0 0;position:relative;}
  .jp-modal-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.2);border:none;color:#fff;font-size:1.1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s;}
  .jp-modal-close:hover{background:rgba(255,255,255,.35);}
  .jp-modal-logo{width:64px;height:64px;border-radius:16px;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:2rem;margin-bottom:14px;border:1.5px solid rgba(255,255,255,.3);}
  .jp-modal-title{font-family:'Poppins',sans-serif;font-weight:700;font-size:1.4rem;color:#fff;margin-bottom:4px;}
  .jp-modal-body{padding:28px;}
  .jp-modal-meta-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:24px;}
  .jp-modal-meta-card{background:#f4fbfc;border:1px solid #d0ecee;border-radius:12px;padding:12px 14px;}
  .jp-modal-meta-card-label{font-size:.75rem;color:#6a9aa2;font-weight:700;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;}
  .jp-modal-meta-card-value{font-weight:700;color:#0d4a55;font-size:.95rem;}
  .jp-modal-section{margin-bottom:20px;}
  .jp-modal-section h4{font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;color:#0d7377;margin-bottom:10px;display:flex;align-items:center;gap:7px;}
  .jp-modal-section p{color:#3a5a64;font-size:.95rem;line-height:1.65;}
  .jp-modal-list{list-style:none;display:flex;flex-direction:column;gap:7px;}
  .jp-modal-list li{display:flex;align-items:flex-start;gap:8px;color:#3a5a64;font-size:.92rem;font-weight:600;}
  .jp-modal-list li::before{content:'✓';color:#0d7377;font-weight:800;flex-shrink:0;}
  .jp-modal-footer{padding:20px 28px 28px;display:flex;gap:12px;border-top:1px solid #eaf5f6;}
  .jp-btn-apply-lg{flex:1;padding:14px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border:none;border-radius:12px;font-family:'Poppins',sans-serif;font-weight:600;font-size:1rem;cursor:pointer;transition:all .2s;box-shadow:0 6px 18px rgba(13,115,119,.3);}
  .jp-btn-apply-lg:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(13,115,119,.38);}
  .jp-btn-save-lg{padding:14px 20px;background:#f0fafc;color:#0d7377;border:1.5px solid #c0e0e4;border-radius:12px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.95rem;cursor:pointer;transition:all .2s;}
  .jp-btn-save-lg:hover{background:#e0f7f3;}
  .jp-pagination{display:flex;justify-content:center;gap:8px;margin-top:10px;}
  .jp-page-btn{width:38px;height:38px;border-radius:10px;border:1.5px solid #c5e5e8;background:#fff;color:#0d7377;font-weight:700;font-size:.9rem;cursor:pointer;transition:all .2s;display:flex;align-items:center;justify-content:center;}
  .jp-page-btn:hover,.jp-page-btn.active{background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border-color:transparent;box-shadow:0 4px 12px rgba(13,115,119,.25);}
  .jp-toast{position:fixed;bottom:28px;right:28px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;padding:14px 22px;border-radius:12px;font-weight:700;font-size:.92rem;z-index:2000;box-shadow:0 8px 24px rgba(13,115,119,.35);animation:slideIn .3s ease;display:flex;align-items:center;gap:9px;}
  @keyframes slideIn{from{transform:translateX(80px);opacity:0}to{transform:translateX(0);opacity:1}}
  @media(max-width:900px){
    .jp-main{grid-template-columns:1fr;padding:20px 16px;}
    .jp-sidebar{position:static;}
    .jp-hero{padding:36px 20px 32px;}
    .jp-hero h1{font-size:1.7rem;}
    .jp-card-title{padding-right:80px;}
    .jp-modal-meta-grid{grid-template-columns:1fr;}
  }
`;

export default function JobPost() {
  const [allJobs, setAllJobs]               = useState([]);
  const [loadingJobs, setLoadingJobs]       = useState(true);
  const [search, setSearch]                 = useState("");
  const [industry, setIndustry]             = useState("All Industries");
  const [jobType, setJobType]               = useState("All Types");
  const [experience, setExperience]         = useState("All Experience");
  const [location, setLocation]             = useState("All Locations");
  const [sortBy, setSortBy]                 = useState("Newest First");
  const [featuredOnly, setFeaturedOnly]     = useState(false);
  const [urgentOnly, setUrgentOnly]         = useState(false);
  const [selectedJob, setSelectedJob]       = useState(null);
  const [savedJobs, setSavedJobs]           = useState([]);
  const [toast, setToast]                   = useState(null);
  const [page, setPage]                     = useState(1);
  const [showAuthModal, setShowAuthModal]   = useState(false);
  const [pendingJob, setPendingJob]         = useState(null);
  const PER_PAGE = 5;

  useEffect(() => {
    const db = getDatabase(app);
    const timer = setTimeout(() => setLoadingJobs(false), 8000);

    const unsub = onValue(
      ref(db, "jobs"),
      (snap) => {
        clearTimeout(timer);
        if (snap.exists()) {
          const data = snap.val();
          const flat = [];
          Object.values(data).forEach((doctorJobs) => {
            if (doctorJobs && typeof doctorJobs === "object") {
              Object.values(doctorJobs).forEach((job) => {
                if (job && typeof job === "object") flat.push(job);
              });
            }
          });
          flat.sort((a, b) => new Date(b.postedAt || 0) - new Date(a.postedAt || 0));
          setAllJobs(flat);
        } else {
          setAllJobs([]);
        }
        setLoadingJobs(false);
      },
      (error) => {
        clearTimeout(timer);
        console.error("Firebase jobs read error:", error);
        setAllJobs([]);
        setLoadingJobs(false);
      }
    );
    return () => { unsub(); clearTimeout(timer); };
  }, []);

  const showToast = (msg, icon = "✅") => {
    setToast({ msg, icon });
    setTimeout(() => setToast(null), 2800);
  };

  const toggleSave = (e, jobId) => {
    e.stopPropagation();
    setSavedJobs((prev) =>
      prev.includes(jobId) ? prev.filter((id) => id !== jobId) : [...prev, jobId]
    );
    showToast(savedJobs.includes(jobId) ? "Job removed from saved" : "Job saved!", "💾");
  };

  const handleApplyClick = (e, job) => {
    e.stopPropagation();
    setPendingJob(job);
    setShowAuthModal(true);
  };

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    if (pendingJob) {
      showToast(`Applied to ${pendingJob.title}!`, "🎉");
      setPendingJob(null);
    }
  };

  const filtered = allJobs.filter((job) => {
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      (job.title || "").toLowerCase().includes(q) ||
      (job.company || "").toLowerCase().includes(q) ||
      (job.specialty || "").toLowerCase().includes(q) ||
      (Array.isArray(job.skills) ? job.skills : []).some((s) => s.toLowerCase().includes(q));
    const matchIndustry  = industry === "All Industries" || job.industry === industry;
    const matchType      = jobType === "All Types" || job.type === jobType;
    const matchLocation  = location === "All Locations" || (job.location || "").toLowerCase().includes(location.toLowerCase());
    const matchFeatured  = !featuredOnly || job.featured;
    const matchUrgent    = !urgentOnly || job.urgent;
    return matchSearch && matchIndustry && matchType && matchLocation && matchFeatured && matchUrgent;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === "Salary High-Low") return 0;
    if (sortBy === "Featured First") return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
    return new Date(b.postedAt || 0) - new Date(a.postedAt || 0);
  });

  const totalPages = Math.ceil(sorted.length / PER_PAGE);
  const paginated  = sorted.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  useEffect(() => { setPage(1); }, [search, industry, jobType, location, featuredOnly, urgentOnly]);

  const relativeDate = (iso) => {
    if (!iso) return "";
    const diff = Date.now() - new Date(iso).getTime();
    const mins  = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days  = Math.floor(diff / 86400000);
    if (mins  < 60)  return `${mins} min${mins !== 1 ? "s" : ""} ago`;
    if (hours < 24)  return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    if (days  <  7)  return `${days} day${days !== 1 ? "s" : ""} ago`;
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  };

  return (
    <>
      <style>{styles}</style>
      <div className="jp-root">

        {/* Hero */}
        <div className="jp-hero">
          <div className="jp-hero-inner">
            <h1>Healthcare <span>Job Portal</span></h1>
            <p>Find top medical careers posted by clinics & hospitals across India</p>
            <div className="jp-search-bar">
              <span>🔍</span>
              <AutosuggestInput
                value={search}
                onChange={(val) => setSearch(val)}
                placeholder="Search by job title, specialty, company or skill..."
                inputStyle={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#fff", fontFamily: "'Nunito', sans-serif", fontSize: "1rem", fontWeight: 500 }}
                limit={6}
              />
              <button className="jp-search-btn">Search Jobs</button>
            </div>
            <div className="jp-stats">
              <div className="jp-stat"><span className="jp-stat-num">{allJobs.length}</span> Live Jobs</div>
              <div className="jp-stat"><span className="jp-stat-num">{allJobs.filter(j=>j.featured).length}</span> Featured</div>
              <div className="jp-stat"><span className="jp-stat-num">{allJobs.filter(j=>j.urgent).length}</span> Urgent Hiring</div>
              <div className="jp-stat"><span className="jp-stat-num">6</span> Specialties</div>
            </div>
          </div>
        </div>

        {/* Industry Quick Filters */}
        <div className="jp-industry-bar">
          <div className="jp-industry-inner">
            {industries.map((ind) => (
              <button
                key={ind}
                className={`jp-ind-btn ${industry === ind ? "active" : ""}`}
                onClick={() => setIndustry(ind)}
              >
                <span className="jp-ind-icon">{industryIcons[ind]}</span>
                {ind}
              </button>
            ))}
          </div>
        </div>

        {/* Main */}
        <div className="jp-main">

          {/* Sidebar */}
          <div className="jp-sidebar">
            <div className="jp-sidebar-title">🔧 Filter Jobs</div>
            <div className="jp-filter-group">
              <div className="jp-filter-label">Job Type</div>
              <select className="jp-filter-select" value={jobType} onChange={(e) => setJobType(e.target.value)}>
                {jobTypes.map((t) => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div className="jp-filter-group">
              <div className="jp-filter-label">Location</div>
              <select className="jp-filter-select" value={location} onChange={(e) => setLocation(e.target.value)}>
                {locations.map((l) => <option key={l}>{l}</option>)}
              </select>
            </div>
            <div className="jp-filter-group">
              <div className="jp-filter-label">Experience</div>
              <select className="jp-filter-select" value={experience} onChange={(e) => setExperience(e.target.value)}>
                {experienceLvl.map((e) => <option key={e}>{e}</option>)}
              </select>
            </div>
            <hr className="jp-filter-divider"/>
            <div className="jp-filter-group">
              <div className="jp-filter-label">Special Filters</div>
              <div className="jp-checkbox-group">
                <label className="jp-checkbox-item">
                  <input type="checkbox" checked={featuredOnly} onChange={(e) => setFeaturedOnly(e.target.checked)}/>
                  ⭐ Featured Jobs Only
                </label>
                <label className="jp-checkbox-item">
                  <input type="checkbox" checked={urgentOnly} onChange={(e) => setUrgentOnly(e.target.checked)}/>
                  🔴 Urgent Hiring Only
                </label>
              </div>
            </div>
            <hr className="jp-filter-divider"/>
            <button className="jp-clear-btn" onClick={() => {
              setSearch(""); setIndustry("All Industries"); setJobType("All Types");
              setLocation("All Locations"); setExperience("All Experience");
              setFeaturedOnly(false); setUrgentOnly(false);
            }}>
              Clear All Filters
            </button>
          </div>

          {/* Listings */}
          <div className="jp-listings">
            <div className="jp-top-bar">
              <div className="jp-count">
                Showing <span>{filtered.length}</span> job{filtered.length !== 1 ? "s" : ""}
                {industry !== "All Industries" ? ` in ${industry}` : ""}
              </div>
              <select className="jp-sort-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option>Newest First</option>
                <option>Salary High-Low</option>
                <option>Featured First</option>
              </select>
            </div>

            {loadingJobs ? (
              <div className="jp-loading">⏳ Loading live jobs…</div>
            ) : paginated.length === 0 ? (
              <div className="jp-no-results">
                <div className="jp-no-results-icon">🔍</div>
                <h3>{allJobs.length === 0 ? "No jobs posted yet" : "No jobs found"}</h3>
                <p>
                  {allJobs.length === 0
                    ? "Doctors can post jobs from their dashboard. Check back soon!"
                    : "Try adjusting your search or filters to find matching opportunities."}
                </p>
              </div>
            ) : (
              paginated.map((job) => (
                <div
                  key={job.id || job.postedAt}
                  className={`jp-card ${job.featured ? "featured" : ""}`}
                  onClick={() => setSelectedJob(job)}
                >
                  <div className="jp-card-badges">
                    {job.featured && <span className="jp-badge jp-badge-featured">⭐ Featured</span>}
                    {job.urgent   && <span className="jp-badge jp-badge-urgent">🔴 Urgent</span>}
                  </div>
                  <div className="jp-card-header">
                    <div className="jp-card-logo">{job.logo || "🏥"}</div>
                    <div className="jp-card-info">
                      {/* ── company name HIDDEN ── */}
                      <div className="jp-card-title">{job.title}</div>
                      <div className="jp-card-meta">
                        <span className="jp-meta-item"><span className="jp-meta-icon">📍</span>{job.location}</span>
                        <span className="jp-meta-item"><span className="jp-meta-icon">💼</span>{job.type}</span>
                        <span className="jp-meta-item"><span className="jp-meta-icon">⏱</span>{job.experience}</span>
                        <span className="jp-meta-item"><span className="jp-meta-icon">🏷</span>{job.specialty}</span>
                      </div>
                      <div className="jp-card-tags">
                        {(Array.isArray(job.skills) ? job.skills : []).map((s) => (
                          <span key={s} className="jp-tag">{s}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="jp-card-footer">
                    {/* ── salary HIDDEN — only posted date shown ── */}
                    <div className="jp-posted">Posted {relativeDate(job.postedAt) || job.posted}</div>
                    <div className="jp-card-actions">
                      <button className="jp-btn-save" onClick={(e) => toggleSave(e, job.id || job.postedAt)}>
                        {savedJobs.includes(job.id || job.postedAt) ? "💙 Saved" : "🤍 Save"}
                      </button>
                      <button className="jp-btn-apply" onClick={(e) => handleApplyClick(e, job)}>
                        Apply Now →
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}

            {totalPages > 1 && (
              <div className="jp-pagination">
                <button className="jp-page-btn" onClick={() => setPage((p) => Math.max(1, p - 1))}>‹</button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    className={`jp-page-btn ${page === i + 1 ? "active" : ""}`}
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button className="jp-page-btn" onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>›</button>
              </div>
            )}
          </div>
        </div>

        {/* Job Detail Modal */}
        {selectedJob && (
          <div className="jp-modal-overlay" onClick={() => setSelectedJob(null)}>
            <div className="jp-modal" onClick={(e) => e.stopPropagation()}>
              <div className="jp-modal-header">
                <button className="jp-modal-close" onClick={() => setSelectedJob(null)}>✕</button>
                <div className="jp-modal-logo">{selectedJob.logo || "🏥"}</div>
                {/* ── company name HIDDEN in modal too ── */}
                <div className="jp-modal-title">{selectedJob.title}</div>
              </div>
              <div className="jp-modal-body">
                <div className="jp-modal-meta-grid">
                  {[
                    { label:"Location",   value: selectedJob.location,                                    icon:"📍" },
                    { label:"Job Type",   value: selectedJob.type,                                        icon:"💼" },
                    { label:"Experience", value: selectedJob.experience,                                  icon:"⏱" },
                    { label:"Industry",   value: selectedJob.industry,                                    icon:"🏥" },
                    { label:"Specialty",  value: selectedJob.specialty,                                   icon:"🔬" },
                    { label:"Posted",     value: relativeDate(selectedJob.postedAt) || selectedJob.posted, icon:"📅" },
                    { label:"Deadline",   value: selectedJob.deadline || "Not specified",                 icon:"⏰" },
                    // ── Salary HIDDEN from modal meta grid ──
                  ].map((m) => (
                    <div key={m.label} className="jp-modal-meta-card">
                      <div className="jp-modal-meta-card-label">{m.icon} {m.label}</div>
                      <div className="jp-modal-meta-card-value">{m.value}</div>
                    </div>
                  ))}
                </div>
                <div className="jp-modal-section">
                  <h4>📋 Job Description</h4>
                  <p>{selectedJob.description}</p>
                </div>
                {selectedJob.requirements?.length > 0 && (
                  <div className="jp-modal-section">
                    <h4>✅ Requirements</h4>
                    <ul className="jp-modal-list">
                      {(Array.isArray(selectedJob.requirements)
                        ? selectedJob.requirements
                        : selectedJob.requirements.split("\n")
                      ).map((r, i) => r && <li key={i}>{r}</li>)}
                    </ul>
                  </div>
                )}
                {selectedJob.skills?.length > 0 && (
                  <div className="jp-modal-section">
                    <h4>🛠 Key Skills</h4>
                    <div className="jp-card-tags">
                      {(Array.isArray(selectedJob.skills) ? selectedJob.skills : []).map((s) => (
                        <span key={s} className="jp-tag">{s}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="jp-modal-footer">
                <button
                  className="jp-btn-apply-lg"
                  onClick={(e) => {
                    setSelectedJob(null);
                    handleApplyClick(e, selectedJob);
                  }}
                >
                  Apply for This Job →
                </button>
                <button
                  className="jp-btn-save-lg"
                  onClick={(e) => toggleSave(e, selectedJob.id || selectedJob.postedAt)}
                >
                  {savedJobs.includes(selectedJob.id || selectedJob.postedAt) ? "💙 Saved" : "🤍 Save Job"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Auth Modal */}
        {showAuthModal && (
          <AuthModal
            job={pendingJob}
            onClose={() => { setShowAuthModal(false); setPendingJob(null); }}
            onSuccess={handleAuthSuccess}
          />
        )}

        {/* Toast */}
        {toast && (
          <div className="jp-toast">
            <span>{toast.icon}</span>
            {toast.msg}
          </div>
        )}
      </div>
    </>
  );
}